import { defaultMeta } from '@enums/common';

const DEFAULT_TAB = {
	page: defaultMeta.page,
	pageSize: defaultMeta.pageSize,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	toDate: null,
	fromDate: null,
	filter: {},
};

export const EVENTS_TABS_NAMES = {
	vesEvents: 'PM data VES Events',
	netconfEvents: 'Netconf Events',
};

export const DEFAULT_TABS = {
	[EVENTS_TABS_NAMES.vesEvents]: DEFAULT_TAB,
	[EVENTS_TABS_NAMES.netconfEvents]: DEFAULT_TAB,
};

export const EVENT_TABS = [
	{
		title: EVENTS_TABS_NAMES.vesEvents,
		value: EVENTS_TABS_NAMES.vesEvents,
		isVisible: true,
	},
	{
		title: EVENTS_TABS_NAMES.netconfEvents,
		value: EVENTS_TABS_NAMES.netconfEvents,
		isVisible: true,
	},
];

